import { MY_BOOKINGS } from '../ids';
import { InstallLocation } from '../types';
export const ids = MY_BOOKINGS;
export const getDefinition = (staticsUrl, t) => ({
    ...ids,
    installLocation: InstallLocation.Standalone,
    showInMemberMenu: true,
    showInLoginMenu: true,
    menuOrder: 2,
    social: false,
    shouldNavigate: false,
    shouldInstallInitially: true,
    urlOverride: 'my-bookings',
    page: {
        name: t('members-area.my-bookings.page.title'),
        shortDescription: t('members-area.my-bookings.page.subtitle'),
        description: t('members-area.my-bookings.page.description'),
        origin: t('members-area.bookings.author'),
        iconURL: `${staticsUrl}assets/images/icons/bookings-icon.png`,
        screenshots: [
            `${staticsUrl}assets/images/my-bookings/my-bookings.png`,
            `${staticsUrl}assets/images/my-bookings/my-bookings-2.png`,
            `${staticsUrl}assets/images/my-bookings/mobile-my-bookings.png`,
            `${staticsUrl}assets/images/my-bookings/mobile-my-bookings-2.png`,
        ],
    },
});
//# sourceMappingURL=my-bookings.js.map